// Leaf module for primitive contact constants. Kept free of yup/validation imports
// so consumers (e.g. _app.tsx) can read these without pulling the validation schemas
// — and therefore yup — into their bundle. The barrel (./index) re-exports these.
export const MobileNumber = 9888552396;
